import { render, staticRenderFns } from "./digit.vue?vue&type=template&id=d33a7840&"
import script from "./digit.vue?vue&type=script&lang=js&"
export * from "./digit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports